import * as React from 'react'

export const ExternalLink: React.FC<{href?: string, children: React.ReactChild, className?: string}> = ( {href, children, className} ) => (
  <a href={ href } className={ className } style={ className ? undefined : { color: 'black' }} target='_blank' rel='noopener noreferrer'>
    { children }
  </a>
)

export default ExternalLink
